import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState, useEffect, useRef } from "react";
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';

export default function ContactForm({ content }) {
    const [isVisible, setIsVisible] = useState(false);
    const componentRef = useRef(null);

    useEffect(() => {
        const onScroll = () => {
            if (!componentRef.current) return;
            const top = componentRef.current.getBoundingClientRect().top;
            if (top < window.innerHeight) setIsVisible(true);
        };
        window.addEventListener("scroll", onScroll);
        onScroll();
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const [formData, setFormData] = useState({});

    const handleChange = (e) =>
        setFormData({ ...formData, [e.target.name]: e.target.value });

    const handleSubmit = (e) => {
        e.preventDefault();
    };

    return (
        <div
            ref={componentRef}
            className={`transition-opacity duration-700 ${isVisible ? "opacity-100" : "opacity-0"
                } bg-black w-full py-20`}
        >
            <h2 className="text-right text-4xl md:text-6xl font-bold mb-10 mr-10">
                <span className="text-yellow-500">{content?.titleLeft}</span>
                <span className="text-white">&nbsp;{content?.titleRight}</span>
            </h2>
            <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-12 text-yellow-500">

                {/* ✅ LEFT INFO — Dynamic */}
                <div className="space-y-4 px-10">

                    {/* India Office */}
                    {content?.indiaOffice && (
                        <div className="space-y-4">
                            <h3 className="text-2xl font-bold underline text-white text-left">
                                {content?.indiaOffice.title}
                            </h3>
                        </div>

                    )}
                    {content?.phone && (
                        <p className="text-lg text-left">
                            <span className="font-semibold">Mob: </span> {content.phone}
                        </p>
                    )}

                    {content?.email && (
                        <a href={`mailto:${content.email}`} className="flex items-center space-x-2 text-yellow-500 hover:text-yellow-300">
                            <FontAwesomeIcon icon={faEnvelope} className="h-5 w-5 text-yellow-500" />
                            <span className="">{content.email}</span>
                        </a>
                    )}
                </div>

                {/* ✅ RIGHT FORM — Dynamic */}
                <div>

                    <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        {content?.fields.map((field, i) => (
                            <div
                                key={i}
                                className={`${field.type === "textarea" ? "md:col-span-2 w-full" : ""}`}
                            >
                                {/* <label className="block text-[#D8C29E] font-medium mb-2">
                                    {field.label}*
                                </label> */}

                                {field.type === "textarea" ? (
                                    <textarea
                                        name={field.name}
                                        value={formData[field.name] || ""}
                                        placeholder={field.placeholder}
                                        onChange={handleChange}
                                        className="col-span-full w-full bg-transparent border border-yellow-500 p-3 rounded-md 
                               text-white placeholder-yellow-500 h-32 resize-none"
                                        required
                                    />
                                ) : (
                                    <input
                                        name={field.name}
                                        type={field.type || "text"}
                                        value={formData[field.name] || ""}
                                        placeholder={field.placeholder}
                                        onChange={handleChange}
                                        className="w-full bg-transparent border border-yellow-500 p-3 rounded-md 
                               text-white placeholder-yellow-500"
                                        required
                                    />
                                )}
                            </div>
                        ))}

                        <div className="md:col-span-2">
                            <button
                                type="submit"
                                className="w-full py-3 border border-yellow-500 rounded-md text-yellow-500 
                       hover:bg-yellow-500 hover:text-black duration-300 text-lg"
                            >
                                {content?.submitText || "Send"}
                            </button>
                        </div>
                    </form>


                </div>

            </div>
        </div>
    );
}
